module.exports = __webpack_public_path__ + "img/feature_buy_freespin_en.092844ec.png";